import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Dropdown, IDropdownOption, DropdownMenuItemType } from '@fluentui/react/lib/Dropdown';

// eslint-disable-next-line no-underscore-dangle
declare let _TL_: any;
interface BoostAnchorsProps {
  i18n: any;
  defaultSelectedKey: string | undefined;
  onUpdate: (key: string | number | undefined) => void;
}

const getDropdownOptions = (i18n): IDropdownOption[] => {
  const options: IDropdownOption[] = [
    { key: 'key1', text: i18n.getString(_TL_('Top Bar')), itemType: DropdownMenuItemType.Header },
    { key: 'ntp_cm_waffle', text: i18n.getString(_TL_('App Launcher')) },
    { key: 'ntp_cm_locationGreeting', text: i18n.getString(_TL_('Location and Weather')) },
    { key: 'ntp_cm_rewardsMedallion', text: i18n.getString(_TL_('Rewards')) },
    { key: 'ntp_cm_notificationBell', text: i18n.getString(_TL_('Notification')) },
    { key: 'ntp_cm_settingsGear', text: i18n.getString(_TL_('Settings')) },
    { key: 'ntp_cm_personalizeButton', text: i18n.getString(_TL_('Personalize Settings')) },

    { key: 'key2', text: '-', itemType: DropdownMenuItemType.Divider },
    { key: 'key3', text: i18n.getString(_TL_('Search Box')), itemType: DropdownMenuItemType.Header },
    { key: 'ntp_cm_searchBox', text: i18n.getString(_TL_('Search')) },

    { key: 'key4', text: '-', itemType: DropdownMenuItemType.Divider },
    { key: 'key5', text: 'Navigation', itemType: DropdownMenuItemType.Header },
    { key: 'ntp_cm_followingNav', text: i18n.getString(_TL_('Following')) },
    { key: 'ntp_cm_gamingNav', text: i18n.getString(_TL_('Gaming')) },
    { key: 'ntp_cm_weatherNav', text: i18n.getString(_TL_('Weather')) },
    { key: 'ntp_cm_watchNav', text: i18n.getString(_TL_('Watch')) },
    { key: 'ntp_cm_shoppingNav', text: i18n.getString(_TL_('Shopping')) },
  ];

  return options;
};

const BoostAnchors: React.FC<BoostAnchorsProps> = forwardRef(({ i18n, defaultSelectedKey, onUpdate }: BoostAnchorsProps, ref) => {
  const [selectedKey, setSelectedKey] = useState<string | number | undefined>(defaultSelectedKey);

  const handleDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    setSelectedKey(option?.key);
  };

  useImperativeHandle(ref, () => ({
    getData: (): string | number | undefined => selectedKey,
  }));

  useEffect(() => {
    if (onUpdate) {
      onUpdate(selectedKey);
    }
  }, [onUpdate, selectedKey]);

  return (
    <Dropdown
      placeholder={i18n.getString(_TL_('Select an option'))}
      label={i18n.getString(_TL_('Select the element on page'))}
      options={getDropdownOptions(i18n)}
      selectedKey={selectedKey}
      onChange={handleDropdownChange}
    />
  );
});

export { BoostAnchors };
